(() => {
  const CUSTOM_WIG_HANDLE = 'custom-wig-order-form';
  const PRICE_PRODUCT_RANGES = [
    { min: 80, max: 299, handle: 'custom-wig-price-80-299' },
    { min: 300, max: 519, handle: 'custom-wig-price-300-519' },
    { min: 520, max: 711, handle: 'custom-wig-price-520-711' },
  ];

  const BASE_PRICES = {
    Topper: 120,
    'Full Cap': 180,
    Frontal: 80,
    'Match My Template': 100,
  };
  const LENGTH_PRICES = { 6: 0, 8: 40, 10: 70, 12: 100, 14: 150, 16: 200, 18: 260, 20: 360 };
  const GREY_PRICES = {
    'No Grey': 0,
    '10% Grey': 8,
    '20% Grey': 8,
    '30% Grey': 8,
    '40% Grey': 8,
    '50% Grey': 8,
    '80% Grey': 13,
    '100% Grey': 13,
  };
  const CURL_PRICES = {
    '4mm medium Afro': 30,
    '6mm loose Afro': 30,
    '8mm extra-loose Afro': 30,
  };
  const BLEACH_PRICES = { 'Bleach knots at front': 5, 'Bleach knots all over': 20 };
  const DENSITY_PRICES = {
    'Extra light 60%': 5,
    'Light 80%': 5,
    'Medium 120%': 5,
    'Medium to Medium-heavy 130%': 5,
    'Medium heavy 140%': 5,
  };
  const PRODUCTION_PRICES = { 'Fastest production 21 days': 59 };
  const PICKUP_PRICES = { 'Pick-up': 39 };

  const fetchProduct = async (handle) => {
    const response = await fetch(`${window.Shopify.routes.root}products/${handle}.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('The custom wig price could not be loaded.');
    return response.json();
  };

  const calculatePrice = (properties, originalVariant) => {
    const colour = properties['Requested Hair Color'] || originalVariant.options[0];
    const grey = originalVariant.options[1];
    const requestedLength = Number.parseInt(properties['Requested Hair Length'] || originalVariant.options[2], 10);
    const basePrice = BASE_PRICES[properties['Base Size']];
    const lengthPrice = LENGTH_PRICES[requestedLength];
    const greyPrice = GREY_PRICES[grey];

    if (basePrice === undefined || lengthPrice === undefined || greyPrice === undefined) {
      throw new Error('One or more priced wig selections are invalid. Please review the form.');
    }

    return basePrice
      + (['#2', '#3', '#4'].includes(colour) ? 5 : 0)
      + lengthPrice
      + greyPrice
      + (CURL_PRICES[properties['Curl and Wave']] || 0)
      + (BLEACH_PRICES[properties['Bleach Knots']] || 0)
      + (DENSITY_PRICES[properties['Hair Density']] || 0)
      + (PRODUCTION_PRICES[properties['Production Time']] || 0)
      + (PICKUP_PRICES[properties['Pick-up']] || 0);
  };

  const findPricingVariant = async (price) => {
    const range = PRICE_PRODUCT_RANGES.find(({ min, max }) => price >= min && price <= max);
    if (!range) throw new Error('The calculated wig price is outside the supported range.');

    const product = await fetchProduct(range.handle);
    const variant = product.variants.find((candidate) => candidate.available && candidate.price === price * 100);
    if (!variant) throw new Error('The calculated wig price is not available. Please contact us.');
    return variant;
  };

  const roots = document.querySelectorAll('[data-custom-wig-studio]');
  if (!roots.length) return;

  const positionWhatsAppWidget = () => {
    const shadowRoot = document.querySelector('gty-whatsapp-chat-button')?.shadowRoot;
    if (!shadowRoot) return false;
    if (shadowRoot.querySelector('[data-wb-custom-wig-whatsapp-position]')) return true;

    const style = document.createElement('style');
    style.setAttribute('data-wb-custom-wig-whatsapp-position', '');
    style.textContent = `
      .gty-wacb-wrapper {
        bottom: 170px !important;
        transition: bottom 0.25s ease !important;
      }

      @media (max-width: 749px) {
        .gty-wacb-wrapper {
          bottom: 210px !important;
        }
      }
    `;
    shadowRoot.appendChild(style);
    return true;
  };

  if (!positionWhatsAppWidget()) {
    let attempts = 0;
    const widgetTimer = window.setInterval(() => {
      attempts += 1;
      if (positionWhatsAppWidget() || attempts >= 80) window.clearInterval(widgetTimer);
    }, 250);
  }

  roots.forEach((root) => {
    const frame = root.querySelector('[data-custom-wig-studio-frame]');
    if (!frame) return;

    const landingUrl = root.dataset.landingUrl;
    const builderUrl = root.dataset.builderUrl;
    const builderOrigin = new URL(builderUrl).origin;
    let addingToCart = false;

    const syncFrame = () => {
      const nextUrl = builderUrl || landingUrl;
      if (nextUrl && frame.src !== nextUrl) frame.src = nextUrl;
      document.title = 'Custom Full-Head Wig Builder | Wig Bangladesh';
    };

    syncFrame();
    window.addEventListener('hashchange', syncFrame);

    window.addEventListener('message', async (event) => {
      if (event.origin !== builderOrigin) {
        return;
      }

      if (event.data?.type === 'wig-customizer:open-builder') {
        window.location.hash = 'design';
        syncFrame();
        return;
      }

      if (
        event.source !== frame.contentWindow ||
        event.data?.type !== 'wig-customizer:add-to-cart' ||
        addingToCart
      ) {
        return;
      }

      const variantId = Number(event.data.variantId);
      const quantity = Number(event.data.quantity || 1);
      const submittedProperties = event.data.properties;
      if (
        !Number.isSafeInteger(variantId) ||
        variantId <= 0 ||
        !Number.isSafeInteger(quantity) ||
        quantity <= 0 ||
        !submittedProperties ||
        typeof submittedProperties !== 'object' ||
        Array.isArray(submittedProperties)
      ) {
        return;
      }

      const properties = {};
      Object.entries(submittedProperties).forEach(([key, value]) => {
        if (typeof key === 'string' && typeof value === 'string' && key.length <= 255 && value.length <= 1000) {
          properties[key] = value;
        }
      });

      addingToCart = true;
      try {
        const customWigProduct = await fetchProduct(CUSTOM_WIG_HANDLE);
        const originalVariant = customWigProduct.variants.find((candidate) => candidate.id === variantId && candidate.available);
        if (!originalVariant) throw new Error('This custom wig combination is not available.');

        const calculatedPrice = calculatePrice(properties, originalVariant);
        const pricingVariant = await findPricingVariant(calculatedPrice);

        properties.Colour = originalVariant.options[0];
        properties['Grey Percentage'] = originalVariant.options[1];
        properties.Length = originalVariant.options[2];
        properties['_Calculated Price USD'] = calculatedPrice.toFixed(2);
        properties['_Original Variant ID'] = String(variantId);
        properties['_Pricing Formula Version'] = '2026-08-01';

        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [{ id: pricingVariant.id, quantity, properties }],
          }),
        });

        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || 'This customization could not be added to the cart.');
        }

        window.location.assign(`${window.Shopify.routes.root}cart`);
      } catch (error) {
        addingToCart = false;
        frame.contentWindow.postMessage(
          {
            type: 'wig-customizer:cart-error',
            message: error instanceof Error
              ? error.message
              : 'This customization could not be added to the cart.',
          },
          builderOrigin,
        );
      }
    });
  });
})();
